import { Actions } from 'Constants'

import { defaultListState, processList } from './InfiniteListReducer'

const defaultState = {
    list: defaultListState,
    selectedId: undefined
}

const Issues = (state = defaultState, action) => {
    switch (action.type) {

        case Actions.UI_ISSUES_LIST:
            return {
                ...state,
                list: processList(state.list, action, (issue) => { return issue.issueId })
            }

        case Actions.UI_CHANGE_COMPANY:
            return defaultState

        case Actions.UI_CHANGE_APP:
            return defaultState

        case Actions.UI_ISSUES_SELECT:
            return {
                ...state,
                selectedId: action.issue.issueId
            }

        default:
        return state
    }
}

export default Issues
